import { SortOption } from '../../../../../ui/components/baseTable/dtos/SortOption.dto'
import { TableColumn } from '../../../../../ui/components/baseTable/dtos/TableColumn.dto'
import ChannelsTagsDisplay from '../components/ChannelsTagsDisplay.vue'

export class NotifiedUserTableColumnsFactory {
	static make(sortOptions: SortOption[]): TableColumn[] {
		return [
			{
				name: 'Nome',
				key: 'name',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'name')?.direction,
			},
			{
				name: 'E-mail',
				key: 'email',
			},
			{
				name: 'Telefone',
				key: 'phoneNumber',
			},
			{
				name: 'Canal de mensagens',
				key: 'channels',
				component: ChannelsTagsDisplay,
			},
		]
	}
}
